import { Loading, Pill } from "@bluframe/blublocks"
import Image from "components/Image"

import { ComponentProps } from "."
import {
  Content,
  Li,
  Pills,
  SubtitlePrimary,
  Subtitles,
  SubtitleSecondary,
  SuggestionPadding,
  Title,
  Wrapper
} from "./styled"

const Suggestion = ({
  ariaLabel,
  image,
  isLoading,
  itemProps: { onMouseDown, onMouseMove, ref, role, ...itemProps },
  onClick,
  pills,
  subtitlePrimary,
  subtitleSecondary,
  title
}: ComponentProps) => (
  <Li
    aria-disabled={itemProps["aria-disabled"]}
    aria-label={ariaLabel}
    aria-selected={itemProps["aria-selected"]}
    onClick={onClick}
    onMouseDown={onMouseDown}
    onMouseMove={onMouseMove}
    ref={ref}
    role={role}
  >
    {isLoading ? (
      <SuggestionPadding>
        <Loading size={24} />
      </SuggestionPadding>
    ) : (
      <Wrapper $hasImage={Boolean(image)}>
        {image ? (
          <Image
            alternativeText={image.alternativeText}
            filename={image.filename}
            formats={image.formats}
            height={image.height}
            sizes="(min-width: 1200px) 2vw, (min-width: 1024px) 2vw, (min-width: 768px) 2vw, 2vw"
            url={image.url}
            width={image.width}
          />
        ) : null}

        <Content>
          <Title>{title}</Title>

          <Subtitles>
            {subtitlePrimary ? (
              <SubtitlePrimary>{subtitlePrimary}</SubtitlePrimary>
            ) : null}

            {subtitleSecondary ? (
              <SubtitleSecondary>{subtitleSecondary}</SubtitleSecondary>
            ) : null}
          </Subtitles>

          {pills?.length ? (
            <Pills>
              {pills.map(({ id, ...pillProps }) => (
                <Pill key={id} size="sm" {...pillProps} />
              ))}
            </Pills>
          ) : null}
        </Content>
      </Wrapper>
    )}
  </Li>
)

Suggestion.displayName = "Suggestion"

export default Suggestion
